import React from "react";

/**
 * Empty object which can be used as defaults.  Do not modify.
 */
export const EMPTY_OBJ: any = {};

/**
 * Empty list obj which can be used as defaults.  Do not modify.
 */
export const EMPTY_LIST: any = [];

/**
 * No operation function that can be used to there's not a thousand
 * empty functions littered throughout the application.
 */
export function Noop() {
    // No op
}

/**
 * Returns an empty div for callbacks that required a
 * returns JSX.Element.
 */
export function NoopDivProvider(): JSX.Element {
    return <div />;
}

export function NoopObjProvider(): any {
    return EMPTY_OBJ;
}
